import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import { MyUrl } from "../../../App";
import moment from "moment";
import { Checkbox } from "@mui/material";
//mport { makeStyles } from "@material-ui/core/styles";
//import { withStyles } from "@mui/styles";
//import CheckIcon from "@material-ui/icons/Check";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
//import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
//import IncomeFirstTable from "./IncomeFirstTable";
//import IncomeGraph from "./IncomeGraph";
//import IncomeSecondTable from "./IncomeSecondTable";
import jwt_decode from "jwt-decode";
import Lottie from "lottie-react";
import UnboxtheBlackbox from "../../UnboxtheBlackbox.json";
// import loading33refresh from "../../../loading33refresh.json";
// import loadingrefresh from "../../../loadingrefresh.json";
// import refreshicon from "../../../refreshicon.json";
import reloadpage from "../../reloadpage.json";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { Button, Modal, Divider, Input, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import DashboardFirstTable from "../DashboardComponents/DashboardFirstTable";
import SourceManagementFirstTable from "../SourceManagementComponents/SourceManagementFirstTable";
import MainPageLeftDrawer from "./MainPageLeftDrawer";
import add from "../../Images/add.png";
var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};
var ObjSendDataToFirstTable2 = {};

var jwtToken = "";

var SendDataToFirstTable1 = [];
var ObjSendDataToFirstTable1 = {};

var SendDataToIncomeGraph = [];
var ObjSendDataToIncomeGraph = {};
var SendDataToIncomeGraph1 = [];
var SendDataToSecondTable = [];
var SendDataToSecondTable1 = [];

var TotalOfDailyChange = 0;
var currentValue1 = 0;
var prevValue1 = 0;
var AfterCalc1 = currentValue1 - prevValue1;
var PickedDate = 0;

// const CircleCheckbox = ({ classes, ...props }) => (
//   <Checkbox
//     {...props}
//     classes={{
//       root: classes.root,
//       checked: classes.checked,
//     }}
//     icon={<span className={classes.circle} />}
//     checkedIcon={
//       <span className={classes.checkedIcon}>
//         sss
//         {/* <CheckIcon style={{ fontSize: 16, color: "black" }} /> */}
//       </span>
//     }
//   />
// );
function SourceManagement() {
  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");
  //when pick yesterday
  const Yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  //when pick 7 days
  const SevenDays = moment().subtract(7, "day").format("YYYY-MM-DD");

  //For CheckBox
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  //End for CheckBox

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
    // PickDatesToGetData(event.target.value);
  };
  //End select Days

  const [OpenRange, SetOpenRange] = useState(false);
  var startDate = Today;
  var endDate = Today;

  async function PickDatesToGetData(event) {
    setDays(event);
    if (event === 0) {
      SetOpenRange(false);
      startDate = Today;
      endDate = Today;
      console.log("today1");

      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
      // GetDailyIncomeFunc1(Today, Today);
      // GetMonthlyIncomeFunc(Today, Today);
    } else if (event === 1) {
      SetOpenRange(false);
      startDate = Yesterday;
      endDate = Yesterday;
      console.log("Yesterday1");
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 2) {
      SetOpenRange(false);
      startDate = SevenDays;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 3) {
      SetOpenRange(false);
      startDate = FirstDayInMonth;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 4) {
      if (value.$D === undefined) {
        startDate = Today;
      } else {
        startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
      }
      if (value1.$D === undefined) {
        endDate = Today;
      } else {
        endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
      }
      SetOpenRange(true);
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    }
  }
  const [height, width] = useWindowSize();

  const [Loading, setLoading] = useState(false);
  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState("");
  const [isLoading1, setIsLoading1] = useState(true);
  const [data1, setData1] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);
  const [data2, setData2] = useState("");

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  const currentDate = moment();
  const daysInCurrentMonth = currentDate.daysInMonth();
  const [selectedObject, setSelectedObject] = useState(true);
  const [count, setCount] = useState(0);

  const handleCheckboxChange = (event, productName) => {
    if (event.target.checked) {
      setChooceCompanies([...chooceCompanies, productName]); // add to array
    } else {
      setChooceCompanies(
        chooceCompanies.filter((name) => name !== productName)
      );
      console.log(chooceCompanies);
      console.log(SendDataToSecondTable);
      console.log("SendDataToIncomeGraph1");
      console.log(SendDataToSecondTable1);
    }
  };
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const urlParams1 = window.location.search;

  //console.log(urlParams1.replace("?", ""));
  const IdsToGetData = []; //chooceCompanies.map((id) => "," + String(id)).join("");

  const getCustomersData1 = () => {
    setIsLoading(true);
    try {
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetSeats?clearCacheForUpload=false`
        )
        .then((res) => {
          const data = res.data;
          setData(data);
          //console.log(data);
          for (let i = 0; i < data.length; i++) {
            //console.log(data[i].id);
            IdsToGetData.push(data[i].id);
            //console.log(IdsToGetData);

            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {}
  };

  const items = localStorage.getItem("Token");

  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  //console.log(aa);

  const [ObjectForChange, setObjectForChange] = useState({});

  const getCustomersData = (startDate, endDate) => {
    try {
      setLoading(false);
      // console.log(endDate);
      // console.log(chooceCompanies.toString());
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetSources`,
          // `https://dsp-api.o2rintelligence.com/api/Dashboard/GetDashboardReport?dateFrom=${startDate}&dateTo=${endDate}&seatids=${chooceCompanies.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
            //cancelToken: source.token,
          }
        )
        .then((res) => {
          const data = res.data;
          console.log(data);
          SendDataToFirstTable = [];

          for (let i = 0; i < data.length; i++) {
            if (Number(urlParams1.replace("?", "")) === data[i].sourceId) {
              setIsModalOpen(true);
              setTargeting(data[i].targeting);
              setGeo(data[i].geo);
              setObjectForChange({
                ...ObjectForChange,
                seatName: data[i].seatName,
                sourceId: data[i].sourceId,
                sourceName: data[i].sourceName,
                channelId: data[i].channelId,
                channelName: data[i].channelName,
                environment: data[i].environment,
                targeting: data[i].targeting,
                trafficSource: data[i].trafficSource,
                geo: data[i].geo,
                Action: data[i].seatName,
              });
              console.log(ObjectForChange);
              console.log("We have one");
            } else {
              console.log("We don't have one");
            }
            ObjSendDataToFirstTable = {
              id: data[i].id,
              seatId: data[i].seatId,
              seatName: data[i].seatName,
              sourceId: data[i].sourceId,
              sourceName: data[i].sourceName,
              channelId: data[i].channelId,
              channelName: data[i].channelName,
              environment: data[i].environment,
              targeting: data[i].targeting,
              trafficSource: data[i].trafficSource,
              geo: data[i].geo,
              Action: data[i].seatName,
            };
            SendDataToFirstTable.push(ObjSendDataToFirstTable);
          }
        })

        .catch((error) => {})
        .finally(() => {
          setLoading(true);
        });
    } catch (err) {}
  };

  useEffect(() => {
    setChooceCompanies([]);
    getCustomersData1();
    //    getCustomersData1();
    const items = localStorage.getItem("Token");
    //console.log(items.replace("?jwt=", ""));
    //await getCustomersData(startDate, endDate, chooceCompanies.toString());
  }, []);
  var [value, setValue] = React.useState(startDate);
  var [value1, setValue1] = React.useState(endDate);
  const handleChange3 = (newValue) => {
    setValue(newValue);
    startDate = `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`;
  };

  const handleChange4 = (newValue1) => {
    setValue1(newValue1);
    endDate = `${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`;
  };
  const [isClicked, setIsClicked] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    console.log("Edit");
    EditSource();

    setIsModalOpen(false);
  };
  const handleCancel = () => {
    console.log("cancel");

    setIsModalOpen(false);
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const handleOk1 = () => {
    CreateNewSource();
    console.log("Create");
    setIsModalOpen1(false);
  };
  const handleCancel1 = () => {
    console.log("cancel");

    setIsModalOpen1(false);
  };
  const items2 = [
    {
      label: <a href="https://www.antgroup.com">1st menu item</a>,
      key: "0",
    },
    {
      label: <a href="https://www.aliyun.com">2nd menu item</a>,
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];

  const [Targeting, setTargeting] = React.useState();
  const [Geo, setGeo] = React.useState();

  const handleChangeTargeting = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      targeting: event.target.value,
    }));
    //setTargeting(event.target.value);
    //console.log(Targeting);
  };

  const handleChangeGeo = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      geo: event.target.value,
    }));
    //setGeo(event.target.value);
    //console.log(Geo);
  };

  const [dataFromChild, setDataFromChild] = useState(null);

  const receiveDataFromChild = (data) => {
    console.log(data);
    // setIsModalOpen(data.dataToSend);
    // setDataFromChild(data);
    // setIsModalOpen(true);
    // setTargeting(data.targeting);
    // setGeo(data.geo);
    // setObjectForChange({
    //   ...ObjectForChange,
    //   id: data.id,
    //   geo: data.geo,
    //   seatId: data.seatId,
    //   targeting: data.targeting,
    //   sourceId: data.sourceId,
    //   sourceName: data.sourceName,
    //   environment: data.environment,
    // });
    // console.log(ObjectForChange);
    // console.log("We have one");
  };

  const [ObjectForDelete, setObjectForDelete] = useState();

  const receiveDataFromChildForDelete = (data) => {
    // console.log(data.dataToSendForDelete);
    // console.log(data.sourceId);
    setIsModalOpen2(data.dataToSendForDelete);
    setObjectForDelete(data.id);
    console.log(ObjectForDelete);
    console.log("We have one");
  };
  console.log(ObjectForDelete);

  const [ObjectCreateSource, setObjectCreateSource] = useState({});
  const [Seat1, setSeat1] = useState("O2R");
  const [SourceId1, setSourceId1] = useState("");
  const [SourceName1, setSourceName1] = useState("");

  const [Environment1, setEnvironment1] = useState("CTV");
  const [Targeting1, setTargeting1] = useState("RON");
  const [Geo1, setGeo1] = useState("US");

  const handleChangeSeat1 = (event) => {
    setSeat1(event.target.value);
    console.log(Seat1);
  };
  const handleChangeSourceId1 = (event) => {
    setSourceId1(event.target.value);
    console.log(SourceId1);
  };
  const handleChangeSourceName1 = (event) => {
    setSourceName1(event.target.value);
    console.log(SourceName1);
  };
  const handleChangeEnvironment1 = (event) => {
    setEnvironment1(event.target.value);
    console.log(Environment1);
  };
  const handleChangeTargeting1 = (event) => {
    setTargeting1(event.target.value);
    console.log(Targeting1);
  };
  const handleChangeGeo1 = (event) => {
    setGeo1(event.target.value);
    console.log(Geo1);
  };

  const CreateNewSource = async (event) => {
    var newObj = {
      id: 0,
      sourceId: SourceId1,
      seatId: 1,
      sourceName: SourceName1,
      trafficSource: "",
      environment: Environment1,
      targeting: Targeting1,
      geo: Geo1,
      wl: "",
      whiteListId: "",
      prevWhiteListId: "",
    };
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/AddSource`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("Created");
      getCustomersData(startDate, endDate);

      //CallData1();
    } catch (error) {
      console.log("error in Create Source");
    }
  };

  const EditSource = async (event) => {
    var newObj = {
      id: ObjectForChange.id,
      sourceId: ObjectForChange.sourceId,
      seatId: ObjectForChange.seatId,
      sourceName: ObjectForChange.sourceName,
      trafficSource: "",
      environment: ObjectForChange.environment,
      targeting: ObjectForChange.targeting,
      geo: ObjectForChange.geo,
      wl: {
        id: 111,
        name: "tg-00",
        sources: [],
        seatId: 3,
        seatName: "Shauking",
        environment: "CTV",
        bundles: [
          {
            id: 0,
            appName: "",
            appsBundle: "",
            appStoreURL: "",
            appid: "",
            os: "",
            siteid: null,
            sitestr: "",
            error: "",
          },
        ],
        error: "",
      },
      whiteListId: "111",
      prevWhiteListId: "",
    };

    // var newObj = {
    //   id: ObjectForChange.id,
    //   sourceId: ObjectForChange.sourceId,
    //   seatId: ObjectForChange.seatId,
    //   sourceName: ObjectForChange.sourceName,
    //   trafficSource: "",
    //   environment: ObjectForChange.environment,
    //   targeting: ObjectForChange.targeting,
    //   geo: ObjectForChange.geo,
    //   wl: "",
    //   whiteListId: "",
    //   prevWhiteListId: "",
    // };
    console.log(newObj);
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateSource`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log(response);
      getCustomersData(startDate, endDate);
      //CallData1();
    } catch (error) {
      console.log("error in Edit Source");
    }
  };
  //484
  const DeleteSource = async (event) => {
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      console.log(ObjectForDelete);
      const response = await axios.delete(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/DeleteSource?id=${ObjectForDelete}`,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("deleted");
      getCustomersData(startDate, endDate);

      //CallData1();
    } catch (error) {
      console.log("error in delete Source");
    }
  };
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const handleOk2 = () => {
    //CreateNewSource();
    DeleteSource();
    console.log("delete");
    setIsModalOpen2(false);
  };
  const handleCancel2 = () => {
    console.log("cancel");
    setIsModalOpen2(false);
  };
  function OpenModalDeleteFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Delete"
          width={"50%"} // Set the width of the Modal
          title="Delete Source"
          open={isModalOpen2}
          onOk={handleOk2}
          onCancel={handleCancel2}
        >
          <p>{ObjectForDelete}</p>
        </Modal>
      </div>
    );
  }
  function OpenModalCreateFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Create"
          width={"50%"} // Set the width of the Modal
          title="Create Source"
          open={isModalOpen1}
          onOk={handleOk1}
          onCancel={handleCancel1}
        >
          <div style={{}}>
            {/* <a style={{ color: "black" }}>Seat</a> */}
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Seat</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Seat1}
                  label="Seat"
                  onChange={handleChangeSeat1}
                >
                  <MenuItem value={"Shauking"}>Shauking</MenuItem>
                  <MenuItem value={"O2R"}>O2R</MenuItem>
                  <MenuItem value={"TQ"}>TQ</MenuItem>
                  <MenuItem value={"Oshi"}>Oshi</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <a style={{ color: "black" }}>Source Id</a>
          <Input
            style={{ height: "55px" }}
            placeholder="Source id"
            value={SourceId1}
            onChange={handleChangeSourceId1}
          />
          <br></br>
          <a style={{ color: "black" }}>Source Name</a>
          <Input
            style={{ height: "55px" }}
            placeholder="Source Name"
            value={SourceName1}
            onChange={handleChangeSourceName1}
          />
          <br></br>
          <br></br>

          <div style={{}}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Environment
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Environment1}
                  label="Environment"
                  onChange={handleChangeEnvironment1}
                >
                  <MenuItem value={"CTV"}>CTV</MenuItem>
                  <MenuItem value={"Mobile App"}>Mobile App</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <br></br>

          <div style={{}}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Targeting</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Targeting1}
                  label="Targeting"
                  onChange={handleChangeTargeting1}
                >
                  <MenuItem value={"RON"}>RON</MenuItem>
                  <MenuItem value={"WL"}>WL</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <br></br>

          <div style={{}}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Geo</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Geo1}
                  label="Geo"
                  onChange={handleChangeGeo1}
                >
                  <MenuItem value={"US"}>US</MenuItem>
                  <MenuItem value={"CA"}>CA</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          {/* <p>Some contents...</p> */}
        </Modal>
      </div>
    );
  }

  function OpenModalEditFunc() {
    return (
      <div>
        <Modal
          okText="Edit"
          width={"50%"} // Set the width of the Modal
          title="Edit Source"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <a style={{ color: "black" }}>Source id</a>
          <Input
            placeholder="Source id"
            value={ObjectForChange.sourceId}
            //onChange={handleChangeSourceId}
          />
          <br></br>
          <br></br>

          <a style={{ color: "black" }}>Source Name</a>
          <Input
            placeholder="Source Name"
            value={ObjectForChange.sourceName}
            onChange={handleChangeSourceName}
          />
          <br></br>
          <br></br>
          <a style={{ color: "black" }}>Environment</a>
          <Input
            placeholder="Environment"
            value={ObjectForChange.environment}
            onChange={handleChangeEnvironment}
          />
          <br></br>
          <br></br>
          <dvi
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 80,
              display: "flex",
              alignItems: "center",
            }}
          >
            <a style={{ color: "black", cursor: "text", fontSize: 20 }}>
              Targiting
            </a>
            <div
              style={
                {
                  //width: "100px",
                  //height: "50px",
                }
              }
            >
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Targiting
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Targeting}
                    label="Targiting"
                    onChange={handleChangeTargeting}
                  >
                    <MenuItem value={"RON"}>RON</MenuItem>
                    <MenuItem value={"WL"}>WL</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <a style={{ color: "black", cursor: "text", fontSize: 20 }}>Geo</a>
            <div></div>
            <div style={{}}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Geo</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Geo}
                    label="Geo"
                    onChange={handleChangeGeo}
                  >
                    <MenuItem value={"US"}>US</MenuItem>
                    <MenuItem value={"CA"}>CA</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </dvi>
          {/* <p>Some contents...</p> */}
        </Modal>
      </div>
    );
  }

  const handleChangeSourceName = (event) => {
    // Use the spread operator to create a new object with the updated value
    setObjectForChange((prevState) => ({
      ...prevState,
      sourceName: event.target.value,
    }));
    console.log(event);
    console.log(ObjectForChange);
  };

  const handleChangeEnvironment = (event) => {
    // Use the spread operator to create a new object with the updated value
    setObjectForChange((prevState) => ({
      ...prevState,
      environment: event.target.value,
    }));
    console.log(event);
    console.log(ObjectForChange);
  };

  return (
    <div
      style={{
        //flex: 1,
        //  display: "flex", // For desktop should flex it  put for mobile when unable it (no flex)
        // paddingRight: "1%",
        display: "flex", // width > 766 ? "flex" : "",
        flexGrow: 1,
      }}
    >
      {/* <MainPageLeftDrawer /> */}
      <div style={{ width: "100%" }}>
        {Loading ? (
          <>
            <SourceManagementFirstTable
              onSendDataForDelete={receiveDataFromChildForDelete}
              onSendData={receiveDataFromChild}
              SendDataToFirstTable={SendDataToFirstTable}
              startDate={startDate}
              endDate={endDate}
            />
            <div
              style={{
                justifyContent: "flex-end",
                display: "flex",
                height: 80,
              }}
            >
              <img
                src={add}
                style={{
                  width: 80,
                  cursor: "pointer",
                  paddingRight: 40,
                }}
                onClick={() => {
                  setIsModalOpen1(true);
                }}
              ></img>
            </div>
            <div style={{ flex: 0, display: "flex" }}>
              {OpenModalCreateFunc()}
              {OpenModalDeleteFunc()}
              {OpenModalEditFunc()}
            </div>
          </>
        ) : (
          <div
            style={{
              flex: 1,
              height: 500,
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Skeleton
              animation="wave"
              width={window.innerWidth}
              height={"100%"}
              borderRadius={100}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default withRouter(SourceManagement);
